/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { EntityId, List, ShareLink, ShareLinkName } from "./data-contracts";

/**
 * @description Returns a paginated list of share links configured for the site. Share links grant access to a private site without requiring full authentication. Use this to audit existing share links, check their active status, or find a link ID before updating or revoking it.
 * @tags site-share-links
 * @name ListSiteShareLinks
 * @summary List all private share links for a site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/share-links
 * @secure
 */

// @ts-ignore
export const listSiteShareLinks: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Search share links by name or key */
    search?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: ShareLink[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/share-links",
  method: "get",
  streaming: false,
  tags: ["site-share-links"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Creates a new named share link that grants access to the private site without requiring full user authentication. Share links are useful for sharing pre-publication content with reviewers or stakeholders. Each link has a unique key and can be activated or deactivated independently.
 * @tags site-share-links
 * @name CreateSiteShareLink
 * @summary Create a private share link for a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/share-links
 * @secure
 */

// @ts-ignore
export const createSiteShareLink: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Name of the share link */
    name: ShareLinkName;
  };
  RequestHeaders: {};
  ResponseBody: ShareLink;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/share-links",
  method: "post",
  streaming: false,
  tags: ["site-share-links"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Updates a share link's properties. Use this to temporarily disable a share link without losing its configuration.
 * @tags site-share-links
 * @name UpdateSiteShareLinkById
 * @summary Update a private share link for a site
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}
 * @secure
 */

// @ts-ignore
export const updateSiteShareLinkById: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the share link */
    shareLinkId: string;
  };
  RequestQuery: {};
  RequestBody: {
    active?: boolean;
    /** Name of the share link */
    name?: ShareLinkName;
  };
  RequestHeaders: {};
  ResponseBody: ShareLink;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}",
  method: "patch",
  streaming: false,
  tags: ["site-share-links"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-share-links
 * @name DeleteSiteShareLinkById
 * @summary Deletes a share link
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}
 * @secure
 */

// @ts-ignore
export const deleteSiteShareLinkById: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the share link */
    shareLinkId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/share-links/{shareLinkId}",
  method: "delete",
  streaming: false,
  tags: ["site-share-links"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
